var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MStateBox,{staticClass:"ir-module-block",attrs:{"loading":_setup.announcement.loading,"empty":_setup.isEmpty}},[_vm._l((_setup.pageData),function(item,index){return _c(_setup.CCardNoticePanel,{key:index,attrs:{"item":item}})}),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }